import React from 'react'

const Pill = ({ children }) => {
  return (
    <div className="w-auto flex items-center text-nowrap text-white bg-ternary h-auto justify-center py-2 px-4 rounded-2xl">
      {children}
    </div>
  )
}

export default Pill
